<template>
  <q-input
    :model-value="timeIn12"
    v-bind="$attrs"
    class="col-6"
    :label="label"
  >
    <template #append>
      <q-icon
        name="access_time"
        class="cursor-pointer"
      >
        <q-popup-proxy
          transition-show="scale"
          transition-hide="scale"
        >
          <q-time
            :model-value="timeIn24"
            @update:model-value="setTime"
          >
            <div class="row items-center justify-end">
              <q-btn
                v-close-popup
                label="Close"
                color="primary"
                flat
              />
            </div>
          </q-time>
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>

import { IsoDateTime } from 'src/models/model'

export default {
  name: 'TimeSetter',
  props: {
    time: {
      type: Date,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update-time'],
  computed: {
    timeIn24 () {
      // Returns time in 24 hour format, required for q-time component
      return this.time ? IsoDateTime.parse(this.convertedTime).i18n('hourMinuteDigits24') : null
    },
    timeIn12 () {
      // Returns time in 12 hour format, required for viewing in q-input (uses AM/PM)
      return this.time ? IsoDateTime.parse(this.convertedTime).i18n('hourMinuteDigits') : null
    },
    convertedTime () {
      return this.$mh.toLocalTime(this.time)
    }
  },
  methods: {
    setTime (newTime) {
      const values = newTime.split(':')
      const hours = values[0]
      const minutes = values[1]

      // Since we have to convert the time to the site's timezone, we need to get the original time in the site's timezone
      const originalValues = this.convertedTime.toTimeString().split(':')
      const originalHours = originalValues[0]
      const originalMinutes = originalValues[1]

      const hourDifference = hours - originalHours
      const minuteDifference = minutes - originalMinutes

      // After calculating the difference, we need to update the original unconverted time
      const updatedTime = new Date(this.time)

      const newHours = updatedTime.getHours() + hourDifference
      const newMinutes = updatedTime.getMinutes() + minuteDifference

      updatedTime.setHours(newHours)
      updatedTime.setMinutes(newMinutes)

      this.$emit('update-time', updatedTime)
    }
  }

}

</script>
